import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../contexts/UserContext.tsx";

export default function AddMathlabUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    mobile_num: "",
    roll_num: "",
    school_year: "",
    section: "",
    current_grade: null,
    school_id: sessionStorage.getItem("curr_school_id") || null,
    user_password: "",
  });
  useEffect(() => {
    if (user.user_type !== "admin") {
      return navigate("/");
    }
  }, [user.user_type, navigate]);
  // if (parseInt(user.view_access_list.schoolID) !== parseInt(id)) {
  //   toast.error("You are not authorized to view this page");
  //   return <h1>Unauthorized</h1>;
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      userData.first_name === "" ||
      userData.last_name === "" ||
      userData.mobile_num === "" ||
      userData.roll_num === "" ||
      userData.school_year === "" ||
      userData.section === "" ||
      userData.current_grade === null ||
      userData.user_password === ""
    ) {
      toast.error("Please fill all fields");
      return;
    }
    toast.info("Adding user...");
    if (userData.school_id === null || userData.school_id === undefined) {
      userData.school_id = parseInt(sessionStorage.getItem("curr_school_id"));
    }
    if (!userData.school_id) {
      toast.error("Failed to get school ID. Please refresh and try again.");
      return;
    }
    await axiosInstance
      .post("/addMathLabUser", {
        ...userData,
        auth_token: user.auth_token,
      })
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        toast.success("User added successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <Paper elevation={3} className="w-fit mx-auto my-auto px-10">
      <h1 className="text-center p-4 font-semibold text-2xl text-green-600">
        Add Mathlab User
      </h1>
      <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, maxWidth: "40ch" },
        }}
        noValidate
        autoComplete="off"
      >
        <div className="grid grid-cols-2">
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            onChange={(e) =>
              setUserData({ ...userData, first_name: e.target.value })
            }
            name="first_name"
            label="First Name"
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="last_name"
            label="Last Name"
            onChange={(e) =>
              setUserData({ ...userData, last_name: e.target.value })
            }
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="user_password"
            label="Password"
            type="password"
            onChange={(e) =>
              setUserData({ ...userData, user_password: e.target.value })
            }
          />
          {!id && (
            <TextField
              sx={{
                backgroundColor: "#f5f5f5",
              }}
              name="school_id"
              label="School ID"
              value={sessionStorage.getItem("curr_school_id")}
              disabled
            />
          )}
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="current_grade"
            label="Current Grade"
            onChange={(e) =>
              setUserData({ ...userData, current_grade: e.target.value })
            }
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="section"
            label="Section"
            onChange={(e) =>
              setUserData({ ...userData, section: e.target.value })
            }
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="school_year"
            label="School Year"
            onChange={(e) =>
              setUserData({ ...userData, school_year: e.target.value })
            }
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="roll_num"
            label="Roll no."
            onChange={(e) =>
              setUserData({ ...userData, roll_num: e.target.value })
            }
          />
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#4CAF50",
                  color: "#4CAF50",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#4CAF50",
              },
            }}
            name="mobile_num"
            label="Mobile no."
            onChange={(e) =>
              setUserData({ ...userData, mobile_num: e.target.value })
            }
          />
        </div>
        <div className="w-full flex justify-center p-10 gap-4 red">
          <Button
            variant="contained"
            sx={{
              backgroundColor: "rgb(220 38 38)",
              color: "white",
              "&:hover": {
                backgroundColor: "rgb(239, 68, 68)",
              },
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#4CAF50",
              color: "white",
              "&:hover": {
                backgroundColor: "#45a049",
              },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Box>
    </Paper>
  );
}
